import React from 'react';
import Icon from './Icon';
import { SERVICES } from '../data/content';

export default function Services() {
  return (
    <section id="services" className="section">
      <div className="container">
        <div className="section-header reveal">
          <span className="eyebrow">What We Do</span>
          <h2 className="section-title">Solutions Built to Modernize &amp; Automate Your Business</h2>
          <p className="section-subtitle">
            From day-to-day IT operations to enterprise-wide automation, our service pillars cover
            the full technology lifecycle.
          </p>
        </div>

        <div className="services-grid">
          {SERVICES.map((service, i) => (
            <div className="service-card reveal" key={service.title} style={{ transitionDelay: `${i * 0.08}s` }}>
              <div className="service-icon">
                <Icon name={service.icon} size={26} />
              </div>
              <h3>{service.title}</h3>
              <p>{service.desc}</p>
              <ul className="service-list">
                {service.items.map((item) => (
                  <li key={item}>
                    <Icon name="check-circle" size={16} /> {item}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}